<template>
  <div class="setting-popup setting-popup--frame"  v-show="boxData.judgeBox" :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown.stop.prevent>
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      设置
    </div>
    <div class="setting-popup__content">
      <tabs>
        <template slot="panel_0">
          <prop-setting
            :color="color"
            :spriteType="spriteType"
            :canPickColor="sprite.option && (sprite.option.fileType == 32 || sprite.option.fileType == 33)"
            :arrangeAction="arrangeAction"
            :operationsAction="operationsAction"
            :ops="ops"
            ref="propSettingRef"
          ></prop-setting>
        </template>
        <template slot="panel_1">
          <effect-setting v-if="boxData.judgeBox"
          ></effect-setting>
        </template>
      </tabs>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../mixins/popup'
import tabs from './content/tabs'
import propSetting from './content/propSetting'
import effectSetting from './content/effectSetting'

export default {
  mixins: [popup],
  components: {
    propSetting,
    effectSetting,
    tabs
  },
  data () {
    return {
      spriteType: 'setting_Frame',
      color: '',
      ops: [
        {text: '替换', action: 'swap'},
        {text: '翻转', action: 'flip'}
      ]
    }
  },
  watch: {
    'boxData.judgeBox': function (val) {
      if (!this.sprite) {
        return;
      }
      this.$bus.emit('settingPopup.toggle', val);
    }
  },
  mounted () {

  },
  methods: {
    getComponent () {
      return this;
    },
    test () {
      this.$bus.emit('showSelectFrameImage')
    }
  }
}
</script>

<style lang="scss" scoped>
  .setting-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 258px;
    height: 562px;
    z-index: 35;
    border-radius: 6px 6px 3px 3px;
    // border: 1px solid #d8dee9;
    background: #fff;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0 0 3px 1px #d8dee9;
    color: #474261;

    &__drag-area {
      line-height: 28px;
      background: #d8dee9;
      text-align: left;
      text-indent: 14px;
      cursor: move;
    }

    &__close {
      position: absolute;
      top: 7px;
      right: 12px;
      height: 14px;
      line-height: 14px;
      width: 14px;
      cursor: pointer;
    }

    &__content {
      padding: 14px 0;
    }

    &__mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#ffffff, 0.7);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/frameSetting.vue